<script setup>
import { computed, inject } from "vue";
import ButtonLink from "@/Components/Button/Link.vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <img
      src="@/../img/home/contact-us.jpg"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-md"
    />
    <!-- Dark Overlay for Readability -->
    <div class="absolute inset-0 bg-white bg-opacity-60"></div>

    <div class="relative z-10 text-black" style="padding-left:5rem;padding-right:5rem">
      <!-- Main Title -->
      <h1
        class="text-4xl md:text-5xl leading-tight"
      >{{ $t('Neem contact met ons op voor meer informatie') }}</h1>

      <!-- Subtitle -->

      <!-- Buttons -->
      <div class="mt-6 flex flex-wrap gap-4">
        <ButtonLink
          :href="route('contact')"
          class="bg-[#437066] text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#355a50] transition mt-4"
        >{{ $t('Neem contact op') }}</ButtonLink>
      </div>
    </div>
  </div>
</template>